import React, { Component } from 'react';
import './ayacandas_210318-web-resources/css/ayacandas_210318.css';

export class Test extends Component {
    
    
        render() {
          return (
<div>
	<head>
		<meta charset="utf-8" />
		<title>ayacandas_210318</title>
		<link href="ayacandas_210318-web-resources/css/ayacandas_210318.css" rel="stylesheet" type="text/css" />
	</head>
	<body id="ayacandas_210318" >
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links ParaOverride-1"><span class="CharOverride-1">Farben:</span></p>
			<p class="Text_02_LINKS_EINZUG ParaOverride-2">Blau: 30/105/128. #</p>
			<p class="Text_02_LINKS_EINZUG ParaOverride-2">Gelb: 245/229/152, #</p>
			<p class="Text_02_LINKS_EINZUG ParaOverride-2">Schwarz</p>
			<p class="Text_02_LINKS_EINZUG ParaOverride-2">Weiß</p>
			<p class="Text_02_LINKS_EINZUG ParaOverride-2">Grau  50%</p>
			<p class="Titel_01_Links ParaOverride-1"><span class="CharOverride-1">Flächen/Kästchen: </span></p>
			<p class="Titel_01_Links ParaOverride-1"><span class="CharOverride-2">Weiß 70% Transparenz</span></p>
			<p class="Text_02_LINKS_EINZUG ParaOverride-2">Buttons:  Gelb: 245/229/152</p>
			<p class="Text_02_LINKS_EINZUG ParaOverride-2">Suchleiste &amp; Fill-In-Formular-Hintergrund: Grau 200/200/200</p>
			<p class="Text_02_LINKS_EINZUG ParaOverride-2"><span class="CharOverride-4">Schriften:</span></p>
			<p class="header"><span class="CharOverride-1">Header: Open Sans Condensed 40px Weiß</span></p>
			<p class="Titel_04_Links_Abstand ParaOverride-2">Navi: Open Sans Condensed 20px Gelb</p>
			<p class="header"><span class="CharOverride-5">Titel_01: open sans 40px Blau</span></p>
			<p class="Titel_02-Zentriert ParaOverride-3">Titel_02: open sans 30px Blau</p>
			<p class="Titel_04_Links_Abstand ParaOverride-2"><span class="CharOverride-6">Titel_03: Open Sans Bold 20px</span></p>
			<p class="Titel_04_Links_Abstand ParaOverride-2">Titel_04: Open Sans Condensed 18px</p>
			<p class="Titel_04_Links_Abstand ParaOverride-2"><span class="CharOverride-7">Text-01 (Untertitel-01): Open Sans bold 14px blau</span></p>
			<p class="Text_02_LINKS_EINZUG ParaOverride-2">Text-02: Open Sans Regular 14px</p>
			<p class="Titel_03_Zentriert ParaOverride-4"><span class="Link CharOverride-8">Link: Open Sans SemiBold </span><span class="CharOverride-9">14px blau</span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2"><span class="CharOverride-10">Kontaktformular Open Sans Light 10px </span></p>
			<p class="FAQ-Titel_01">FAQ-Titel_01: Open Sans Condensed 8pt</p>
			<p class="FAQ-Text">FAQ-Text: Open Sans Regular 7pt</p>
			<p class="Button-Zum-Angebot">Button </p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2">open sans Bold <span class="CharOverride-11">14px blau</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Ayacandas ist ein Online-Austausch-Marktplatz für IT-Lösungen im Gesundheitswesen.</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_02-Zentriert">Suche</p>
			<p class="Titel_03_Zentriert">Suchen</p>
			<p class="Titel_03_Zentriert">Finden</p>
			<p class="Titel_03_Zentriert">Inspirieren lassen</p>
			<p class="Fill-In-Text">      <span class="CharOverride-12"> I  </span>&#9;   </p>
		</div>
		<div>
			<p class="Titel_02-Zentriert">Suchanregungen</p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Entlassmanagement</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Verordnungsmanagement</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">OH KIS</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Datenschutz</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">DSGVO</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Baurecht </span></p>
		</div>
		<div class="Wei-eFl-chen">
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_02-Zentriert">Aktuelles</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_Aktuelles_fmt.png" alt="Icon_Aktuelles.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_SUCHANREGUNGEN_fmt.png" alt="Icon_SUCHANREGUNGEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_Suche_fmt.png" alt="Icon_Suche.png" />
		</div>
		<div>
			<p class="Titel_02-Zentriert">Anbieten</p>
			<p class="Titel_03_Zentriert"> Registrieren</p>
			<p class="Titel_03_Zentriert">Publizieren</p>
			<p class="Titel_03_Zentriert">Verkaufen lassen </p>
			<p class="Button-Zum-Angebot ParaOverride-5">Login/Registrierung</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_02-Zentriert">Informatives</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_Anbieten_fmt.png" alt="Icon_Anbieten.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_Informatives_fmt.png" alt="Icon_Informatives.png" />
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">Suchen</span>&#9;</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Hier können Sie nach Begriffen über den Marktplatz hinweg suchen</p>
			<p class="Text-01--Untertitel-01-">Mehrere Begriffe können durch Leerzeichen getrennt eingegeben werden. Produkte, die alle Begriffe in Titel oder Beschreibung enthalten, werden gefunden. Foren können nur lokal im jeweiligen Forum durchsucht werden.</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="login-reg"><span class="CharOverride-15"> I </span> &#9;   </p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04_Links_Abstand">Suche filtern nach Typ&#9;&#9;</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6">Angebote aus dem Gesundheitswesen &#9;</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6">Angebote von Firmen&#9;</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6">Angebote von Personen&#9;Dienstleistung&#9;</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6">Software&#9;</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6">Gebraucht-Software&#9;</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6">Dokumente&#9;</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6">Software Forschung &amp; Lehre&#9;</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6">Hardware&#9;</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6">Ausschreibung &#9;</p>
		</div>
		<div>
			<p class="Titel_01_Links">Suchergebnisse</p>
		</div>
		<div class="Wei-eFl-chen">
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04">Integrated Care Manager (ICM) </p>
			<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
				<img class="_idGenPageitem-3" src="ayacandas_210318-web-resources/image/14595.png" alt="14595.png" />
			</div>
			<p class="Text_02_LINKS_EINZUG">Eingeklappte Beschreibung der Suchergebnisse mit maximal <br />zwei Spalten Text, am Ende steht an logischer Stelle ein...</p>
			<p class="Titel_04">Typ<span class="CharOverride-16"> <span><img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt.png" alt="Icon_DOKUMENTE.png" /></span> </span><span class="Link CharOverride-8">Dokument </span></p>
			<p class="Titel_04">Kategorie <span class="Link CharOverride-8">Europ. DSGVO | Bitte abkürzen</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04">Integrated Care Manager (ICM) </p>
			<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
				<img class="_idGenPageitem-3" src="ayacandas_210318-web-resources/image/14743.png" alt="14743.png" />
			</div>
			<p class="Text_02_LINKS_EINZUG">Ausgeklappte Beschreibung der Suchergebnisse mit maximal <br />sechs Spalten Text der logisch beendet wird. Die genaue <br />Produktbeschreibung gibt es dann auf der jweiligen Produktseite <br />- zu errreichen über den „Zum Angebot“-Button.</p>
			<p class="Titel_04">Typ<span class="CharOverride-16"> <span><img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt1.png" alt="Icon_DOKUMENTE.png" /></span> </span><span class="Link CharOverride-8">Dokument </span></p>
			<p class="Titel_04">Kategorie <span class="Link CharOverride-8">Europ. DSGVO | Bitte abkürzen</span></p>
		</div>
		<div class="Wei-eFl-chen">
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04">Integrated Care Manager (ICM) </p>
			<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
				<img class="_idGenPageitem-3" src="ayacandas_210318-web-resources/image/26301.png" alt="26301.png" />
			</div>
			<p class="Text_02_LINKS_EINZUG">Eingeklappte Beschreibung der Suchergebnisse mit maximal <br />zwei Spalten Text, am Ende steht an logischer Stelle ein...</p>
			<p class="Titel_04">Typ<span class="CharOverride-16"> <span><img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt2.png" alt="Icon_DOKUMENTE.png" /></span> </span><span class="Link CharOverride-8">Dokument </span></p>
			<p class="Titel_04">Kategorie <span class="Link CharOverride-8">Europ. DSGVO | Bitte abkürzen</span></p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-5" src="ayacandas_210318-web-resources/image/Icon__MitarbeitendeGesundheitswesen_fmt.png" alt="Icon__MitarbeitendeGesundheitswesen.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-5" src="ayacandas_210318-web-resources/image/Icon_Herstellende_fmt.png" alt="Icon_Herstellende.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-5" src="ayacandas_210318-web-resources/image/Icon_PRIVATperson_fmt.png" alt="Icon_PRIVATperson.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-5" src="ayacandas_210318-web-resources/image/Icon_dienstleistungen_fmt.png" alt="Icon_dienstleistungen.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-5" src="ayacandas_210318-web-resources/image/Icon_SOFTWARE_fmt.png" alt="Icon_SOFTWARE.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-5" src="ayacandas_210318-web-resources/image/Icon_GEBRAUCHSTSOFTWARE_fmt.png" alt="Icon_GEBRAUCHSTSOFTWARE.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-5" src="ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt3.png" alt="Icon_DOKUMENTE.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-5" src="ayacandas_210318-web-resources/image/Icon_LEHRE%2bFORSCHUNG_fmt.png" alt="Icon_LEHRE%2bFORSCHUNG.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-6" src="ayacandas_210318-web-resources/image/Icon_Hardware_fmt.png" alt="Icon_Hardware.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-6" src="ayacandas_210318-web-resources/image/Icon_Ausschreibung_fmt.png" alt="Icon_Ausschreibung.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-7" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt.png" alt="Icon_HAKEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-7" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt1.png" alt="Icon_HAKEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-7" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt2.png" alt="Icon_HAKEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-7" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt3.png" alt="Icon_HAKEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-7" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt4.png" alt="Icon_HAKEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-7" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt5.png" alt="Icon_HAKEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-7" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt6.png" alt="Icon_HAKEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-7" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt7.png" alt="Icon_HAKEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-7" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt8.png" alt="Icon_HAKEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-7" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt9.png" alt="Icon_HAKEN.png" />
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Button-Zum-Angebot">Filter zurücksetzen</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zum Angebot</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zum Angebot</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zum Angebot</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/868.png" alt="868.png" />
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">Suchen</span>&#9;</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Produkt Produktname </p>
		</div>
		<div>
			<p class="Titel_04_Links_Abstand">Typ <span><img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt4.png" alt="Icon_DOKUMENTE.png" /></span> <span class="Link CharOverride-8">Dokument </span>&#9;</p>
			<p class="Titel_04_Links_Abstand">Kategorie <span class="Link CharOverride-8">Europ. DSGVO | Bitte abkürzen oder andere Lösung finden</span></p>
			<p class="Titel_04_Links_Abstand">Bewertung &#9;          <span class="dünn">(123)  </span></p>
			<p class="Titel_04_Links_Abstand">Preis <span class="dünn">XX,XX €</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Text_02_LINKS_EINZUG">Hier steht die ausführliche Beschreibung des ausgewählten Produktes. </p>
			<p class="Text_02_LINKS_EINZUG">Gliederung wie gehabt: </p>
			<p class="Titel_04_Links_Abstand">Inhalt des Dokumentes</p>
			<p class="Text_02_LINKS_EINZUG">Ja, Name des Gesellschaft </p>
			<p class="Titel_04_Links_Abstand">Links</p>
			<p class="Text_02_LINKS_EINZUG"><span class="Link CharOverride-8">https://www.lda.bayern.de/de/datenschutz_eu.html</span></p>
			<p class="Titel_04_Links_Abstand">Tags</p>
			<p class="Text_02_LINKS_EINZUG"><span class="Link CharOverride-8">Datenschutz, DSGVO , IT-Sicherheit, BDSG(neu), Gesetz</span></p>
			<p class="Titel_04_Links_Abstand">Zielgruppe</p>
			<p class="Text_02_LINKS_EINZUG">Krankenhäuser, Kliniken, Reha</p>
			<p class="Titel_04_Links_Abstand">Besonderheiten</p>
			<p class="Text_02_LINKS_EINZUG">Online</p>
			<p class="Titel_04_Links_Abstand">Bisherige Verwendung</p>
			<p class="Text_02_LINKS_EINZUG">KRankenhaus-IT</p>
			<p class="Titel_04_Links_Abstand">Vorlage bei der DFG oder einer Wirtschaftsprüfungsgesellschaft</p>
			<p class="Text_02_LINKS_EINZUG">Ja, Name des Gesellschaft </p>
			<p class="Titel_04_Links_Abstand">Erfolgreiche Begutachtung</p>
			<p class="Text_02_LINKS_EINZUG">Hier steht dann der Name des Gutachtenden</p>
		</div>
		<div>
			<p class="Titel_04 ParaOverride-2">Beschreibung</p>
		</div>
		<div>
			<p class="Button-ohne-HG">Bookmark</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zurück zu den Suchergebnissen</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zum Produktforum</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt10.png" alt="Icon_HAKEN.png" />
		</div>
		<div>
			<p class="Titel_04_Links_Abstand ParaOverride-2"><span class="CharOverride-16">Reviews</span></p>
		</div>
		<div>
			<p class="Titel_04_Links_Abstand ParaOverride-2"><span class="CharOverride-16">Medien</span></p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Anbietende kontaktieren</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Angebot anfordern</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Produkt kaufen</p>
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">Suchen</span>&#9;</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Produkt Produktname </p>
		</div>
		<div>
			<p class="Titel_04_Links_Abstand ParaOverride-7">Typ <span><img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt5.png" alt="Icon_DOKUMENTE.png" /></span> <span class="Link CharOverride-8">Dokument </span>&#9;</p>
			<p class="Titel_04_Links_Abstand ParaOverride-7">Kategorie <span class="Link CharOverride-8">Europ. DSGVO | Bitte abkürzen oder andere Lösung finden</span></p>
			<p class="Titel_04_Links_Abstand ParaOverride-7">Bewertung &#9;          <span class="dünn">(123)  </span></p>
			<p class="Titel_04_Links_Abstand ParaOverride-7">Preis <span class="dünn">XX,XX €</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04_Links_Abstand">Ihre Bewertung für das Produkt</p>
			<p class="Titel_04_Links_Abstand">Bemerkungen</p>
			<p class="Titel_04_Links_Abstand"><span class="CharOverride-19">    |</span></p>
			<p class="Button-Zum-Angebot ParaOverride-8">Bewertung abschicken</p>
			<p class="Titel_04">Alle Bewertungen</p>
			<p class="Titel_04_Links_Abstand">Bewertung vom: <span class="dünn">12.03.2018 </span></p>
			<div class="_idGenPageitem-2">
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25847.png" alt="25847.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25848.png" alt="25848.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25849.png" alt="25849.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25850.png" alt="25850.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25851.png" alt="25851.png" />
				</div>
			</div>
			<p class="Titel_04_Links_Abstand ParaOverride-9">Bemerkung: <span class="dünn">Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. </span></p>
			<p class="Titel_04_Links_Abstand">Bewertung vom: <span class="dünn">10.03.2018 </span></p>
			<div class="_idGenPageitem-2">
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25840.png" alt="25840.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25841.png" alt="25841.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25842.png" alt="25842.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25843.png" alt="25843.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25844.png" alt="25844.png" />
				</div>
			</div>
			<p class="Titel_04_Links_Abstand ParaOverride-9">Bemerkung: <span class="dünn">Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. </span></p>
			<p class="Titel_04_Links_Abstand">Bewertung vom: <span class="dünn">08.02.2018 </span></p>
			<div class="_idGenPageitem-2">
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25855.png" alt="25855.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25856.png" alt="25856.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25857.png" alt="25857.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25858.png" alt="25858.png" />
				</div>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-8" src="ayacandas_210318-web-resources/image/25859.png" alt="25859.png" />
				</div>
			</div>
			<p class="Titel_04_Links_Abstand ParaOverride-9">Bemerkung: <span class="dünn">Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. </span></p>
		</div>
		<div>
			<p class="Titel_04 ParaOverride-2"><span class="CharOverride-16">Beschreibung</span></p>
		</div>
		<div>
			<p class="Button-ohne-HG">Bookmark</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zurück zu den Suchergebnissen</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zum Produktforum</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt11.png" alt="Icon_HAKEN.png" />
		</div>
		<div>
			<p class="Titel_04_Links_Abstand ParaOverride-2">Reviews</p>
		</div>
		<div>
			<p class="Titel_04_Links_Abstand ParaOverride-2"><span class="CharOverride-16">Medien</span></p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Anbietende kontaktieren</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Angebot anfordern</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Produkt kaufen</p>
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">Suchen</span>&#9;</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Produkt: Integrated Care Manager (ICM) </p>
		</div>
		<div>
			<p class="Titel_04_Links_Abstand ParaOverride-7">Typ <span><img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt6.png" alt="Icon_DOKUMENTE.png" /></span> <span class="Link CharOverride-8">Dokument </span>&#9;</p>
			<p class="Titel_04_Links_Abstand ParaOverride-7">Kategorie <span class="Link CharOverride-8">Europ. DSGVO | Bitte abkürzen oder andere Lösung finden</span></p>
			<p class="Titel_04_Links_Abstand ParaOverride-7">Bewertung &#9;          <span class="dünn">(123)  </span></p>
			<p class="Titel_04_Links_Abstand ParaOverride-7">Preis <span class="dünn">XX,XX €</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04_Links_Abstand">Dokumentation</p>
			<p class="Titel_04_Links_Abstand">Beschreibende Bilder oder Screenshots</p>
			<p class="Titel_04_Links_Abstand">Videos</p>
		</div>
		<div>
			<p class="Titel_04 ParaOverride-2"><span class="CharOverride-16">Beschreibung</span></p>
		</div>
		<div>
			<p class="Button-ohne-HG">Bookmark</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zurück zu den Suchergebnissen</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zum Produktforum</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt12.png" alt="Icon_HAKEN.png" />
		</div>
		<div>
			<p class="Titel_04_Links_Abstand ParaOverride-2"><span class="CharOverride-16">Reviews</span></p>
		</div>
		<div>
			<p class="Titel_04_Links_Abstand ParaOverride-2">Medien</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Anbietende kontaktieren</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Angebot anfordern</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Produkt kaufen</p>
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">&#9;&#9;Aktuelles</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Forum zu Name des Produktes hier rein</p>
		</div>
		<div class="_idGenPageitem-2">
			<div class="Wei-eFl-chen">
			</div>
			<div class="Einfacher-Textrahmen">
				<p class="Titel_04">Thema XXXXX</p>
				<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
					<img class="_idGenPageitem-3" src="ayacandas_210318-web-resources/image/25186.png" alt="25186.png" />
				</div>
				<p class="Text_02_LINKS_EINZUG">Eingeklappter Forumstext mit maximal  zwei Spalten Text, <br />am Ende steht an logischer Stelle ein...</p>
				<p class="Titel_04">Autor*in <span class="Link CharOverride-8">KWI</span></p>
			</div>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04">Integrated Care Manager (ICM) </p>
			<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
				<img class="_idGenPageitem-3" src="ayacandas_210318-web-resources/image/25172.png" alt="25172.png" />
			</div>
			<p class="Text_02_LINKS_EINZUG">Ausgeklappter Forumstext mit maximal sechs Spalten Text der logisch beendet wird. </p>
			<p class="Titel_04">Autor*in <span class="Link CharOverride-8">KWI</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Button-Zum-Angebot">Zurück</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Button-Zum-Angebot">Neues Thema erstellen</p>
		</div>
		<div>
			<p class="navi ParaOverride-10"><span class="CharOverride-14">&#9;&#9;Registrierung/Login</span></p>
		</div>
		<div>
			<p class="Titel_01_Links">Login</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="login-reg">Name/Mailadresse&#9; &#9;&#9;          </p>
			<p class="Button-Zum-Angebot ParaOverride-7">Login <span><img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_LOGIN_fmt.png" alt="Icon_LOGIN.png" /></span></p>
		</div>
		<div>
			<p class="Titel_01_Links">Registrierung</p>
		</div>
		<div>
			<p class="Titel_04_Links_Abstand ParaOverride-11">als Privatperson</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_PRIVATperson_fmt1.png" alt="Icon_PRIVATperson.png" />
		</div>
		<div class="Einfacher-Grafikrahmen">
		</div>
		<div>
			<p class="Titel_04_Links_Abstand ParaOverride-11">als Mitarbeitende <br />im Gesundheitswesen</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon__MitarbeitendeGesundheitswesen_fmt1.png" alt="Icon__MitarbeitendeGesundheitswesen.png" />
		</div>
		<div>
			<p class="login-reg">Passwort</p>
			<p class="Button-Zum-Angebot ParaOverride-7">Passwort vergessen?</p>
		</div>
		<div>
			<p class="Titel_04_Links_Abstand ParaOverride-11">als Herstellende</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_Herstellende_fmt1.png" alt="Icon_Herstellende.png" />
		</div>
		<div>
			<p class="navi ParaOverride-10"><span class="CharOverride-14">&#9;&#9;Registrierung/Login</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Registrierung als Privatperson</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04 ParaOverride-2">Allgemeine Angaben</p>
			<p class="login-reg">Vorname</p>
			<p class="login-reg">Name</p>
			<p class="login-reg">Email</p>
			<p class="login-reg">Nutzername</p>
			<p class="login-reg">Passwort</p>
			<p class="login-reg">Passowrt-Bestätigung &#9;</p>
			<p class="Titel_04 ParaOverride-2">Unternehmen (Freiwillige Angaben)</p>
			<p class="login-reg">Firma</p>
			<p class="login-reg">Abteilung</p>
			<p class="Titel_04 ParaOverride-2">Adresse (Freiwillige Angaben)</p>
			<p class="login-reg">Straße</p>
			<p class="login-reg">Hausnummer</p>
			<p class="login-reg">Adresszusatz</p>
			<p class="login-reg">PLZ</p>
			<p class="login-reg">Ort</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2"><span class="CharOverride-21">Land </span></p>
			<p class="L-nderauswahl">Deutschland</p>
			<p class="Text_02_LINKS_EINZUG ParaOverride-12"><span><img class="_idGenPageitem-7" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt13.png" alt="Icon_HAKEN.png" /></span> Ich oder meine Organisation leben nicht <br />primär vom Handel mit Produkten </p>
			<p class="Button-Zum-Angebot ParaOverride-7">Registrieren</p>
		</div>
		<div>
			<p class="navi ParaOverride-10"><span class="CharOverride-14">&#9;&#9;Registrierung/Login</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Registrierung als Mitarbeitende im Gesundheitswesen</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04 ParaOverride-2">Allgemeine Angaben</p>
			<p class="login-reg">Vorname</p>
			<p class="login-reg">Name</p>
			<p class="login-reg">Email</p>
			<p class="login-reg">Nutzername</p>
			<p class="login-reg">Passwort</p>
			<p class="login-reg">Passowrt-Bestätigung &#9;</p>
			<p class="Titel_04 ParaOverride-2">Unternehmen (Freiwillige Angaben)</p>
			<p class="login-reg">Firma</p>
			<p class="login-reg">Abteilung</p>
			<p class="Titel_04 ParaOverride-2">Adresse (Freiwillige Angaben)</p>
			<p class="login-reg">Straße</p>
			<p class="login-reg">Hausnummer</p>
			<p class="login-reg">Adresszusatz</p>
			<p class="login-reg">PLZ</p>
			<p class="login-reg">Ort</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2"><span class="CharOverride-21">Land </span></p>
			<p class="L-nderauswahl">Deutschland</p>
			<p class="Button-Zum-Angebot ParaOverride-7">Registrieren</p>
		</div>
		<div>
			<p class="navi ParaOverride-10"><span class="CharOverride-14">&#9;&#9;Registrierung/Login</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Registrierung als Herstellende</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04 ParaOverride-2">Allgemeine Angaben</p>
			<p class="login-reg">Vorname</p>
			<p class="login-reg">Name</p>
			<p class="login-reg">Email</p>
			<p class="login-reg">Nutzername</p>
			<p class="login-reg">Passwort</p>
			<p class="login-reg">Passowrt-Bestätigung &#9;</p>
			<p class="Titel_04 ParaOverride-2">Unternehmen (Freiwillige Angaben)</p>
			<p class="login-reg">Firma</p>
			<p class="login-reg">Abteilung</p>
			<p class="Titel_04 ParaOverride-2">Adresse (Freiwillige Angaben)</p>
			<p class="login-reg">Straße</p>
			<p class="login-reg">Hausnummer</p>
			<p class="login-reg">Adresszusatz</p>
			<p class="login-reg">PLZ</p>
			<p class="login-reg">Ort</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2"><span class="CharOverride-21">Land </span></p>
			<p class="L-nderauswahl">Deutschland</p>
			<p class="Button-Zum-Angebot ParaOverride-7">Registrieren</p>
		</div>
		<div>
			<p class="navi">&#9;&#9;&#9;<span class="CharOverride-14">Meine Daten</span></p>
		</div>
		<div>
			<p class="Titel_01_Links">Meine Daten</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04_Links_Abstand">Nutzername &#9;Mailadresse&#9;Mail aktiviert&#9;</p>
			<p class="Titel_04_Links_Abstand">Vorname Name</p>
			<p class="Titel_04_Links_Abstand">Eingeloggt als&#9;Firma</p>
			<p class="Titel_04_Links_Abstand">Abteilung</p>
			<p class="Titel_04_Links_Abstand">Adresse </p>
			<p class="Titel_04_Links_Abstand">Adresszusatz&#9;Land</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot ParaOverride-7">Daten  und Passwort bearbeiten</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="CharOverride-23">MMF</span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="CharOverride-23">MartinaMusterfrau@Mustermail.de</span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="CharOverride-23">Martina Musterfrau</span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="CharOverride-23">Privatperson</span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="CharOverride-23">Musterkrankenhaus</span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="CharOverride-23">Musterabteilung</span>&#9;</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="CharOverride-23">Straße Nr. &#9;PLZ Ort/Stadt</span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="CharOverride-23">VH, 3.OG</span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="CharOverride-23">Deutschland</span></p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-5" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt14.png" alt="Icon_HAKEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-9" src="ayacandas_210318-web-resources/image/Icon_PRIVATperson_fmt2.png" alt="Icon_PRIVATperson.png" />
		</div>
		<div>
			<p class="navi">&#9;&#9;&#9;<span class="CharOverride-14">Meine Daten</span></p>
		</div>
		<div>
			<p class="Titel_01_Links">Meine Daten bearbeiten</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04 ParaOverride-2">Allgemeine Angaben</p>
			<p class="login-reg">Martina</p>
			<p class="login-reg">Musterfrau&#9;</p>
			<p class="login-reg">MartinaMusterfrau@Mustermail.de</p>
			<p class="login-reg">MMF</p>
			<p class="Titel_04 ParaOverride-2">Unternehmen (Freiwillige Angaben)</p>
			<p class="login-reg">Musterkrankenhaus</p>
			<p class="login-reg">Musterbteilung</p>
			<p class="Titel_04 ParaOverride-2">Adresse (Freiwillige Angaben)</p>
			<p class="login-reg">Mustergasse</p>
			<p class="login-reg">15&#9;</p>
			<p class="login-reg">VH 3.OG</p>
			<p class="login-reg">10997</p>
			<p class="login-reg">Musterstadt</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2"><span class="CharOverride-21">Land </span></p>
			<p class="L-nderauswahl">Deutschland</p>
			<p class="Titel_04_Links_Abstand ParaOverride-2">Passwort ändern</p>
			<p class="login-reg">Altes Passwort eingeben&#9;</p>
			<p class="login-reg">Neues Passwort eingeben</p>
			<p class="login-reg">Neues Passwort wiederholen&#9;</p>
			<p class="Button-Zum-Angebot ParaOverride-7"><br /><br />Abschicken</p>
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">&#9;Anbieten&#9;</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Willkommen auf Ihrer Produkt-Seite. Hier können Sie Dokumente, Dienstleistungen und vieles mehr anbieten.</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_02-Zentriert">Dienstleistung</p>
			<p class="Titel_02-Zentriert">Software</p>
			<p class="Titel_02-Zentriert">Gebraucht-Software</p>
			<p class="Titel_02-Zentriert">Ausschreibung </p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Meine bisherigen Angebote<br /></p>
			<p class="Titel_04_Links_Abstand ParaOverride-2">   Name&#9;Typ&#9;Preis&#9;Veröffentlicht</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Link CharOverride-8">Produktname</span>&#9;Dokument&#9;XX,XX,-&#9;xx.xx.xxxx&#9;<span><img class="_idGenPageitem-10" src="ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt.png" alt="Icon_bearbeiten.png" /></span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Link CharOverride-8">(= Link zum Produkt)</span>&#9;Dokument&#9;XX,XX,-&#9;xx.xx.xxxx&#9;<span><img class="_idGenPageitem-10" src="ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt1.png" alt="Icon_bearbeiten.png" /></span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Link CharOverride-8">Produktname</span>&#9;Dokument&#9;XX,XX,-&#9;xx.xx.xxxx&#9;<span><img class="_idGenPageitem-10" src="ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt2.png" alt="Icon_bearbeiten.png" /></span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Link CharOverride-8">Produktname </span>&#9;Dokument&#9;XX,XX,-&#9;xx.xx.xxxx&#9;<span><img class="_idGenPageitem-10" src="ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt3.png" alt="Icon_bearbeiten.png" /></span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Meine bisherigen Käufe<br /></p>
			<p class="Titel_04_Links_Abstand ParaOverride-2">   Name&#9;Typ&#9;Preis&#9;Gekauft am</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Link CharOverride-8">Produktname</span>&#9;Dokument&#9;XX,XX,-&#9;xx.xx.xxxx&#9;<span><img class="_idGenPageitem-10" src="ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt4.png" alt="Icon_bearbeiten.png" /></span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Link CharOverride-8">(= Link zum Produkt)</span>&#9;Dokument&#9;XX,XX,-&#9;xx.xx.xxxx&#9;<span><img class="_idGenPageitem-10" src="ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt5.png" alt="Icon_bearbeiten.png" /></span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Link CharOverride-8">Produktname</span>&#9;Dokument&#9;XX,XX,-&#9;xx.xx.xxxx&#9;<span><img class="_idGenPageitem-10" src="ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt6.png" alt="Icon_bearbeiten.png" /></span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Bookmarks<br /></p>
			<p class="Titel_04_Links_Abstand ParaOverride-2">   Name&#9;Typ&#9;&#9;Gesucht am</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Link CharOverride-8">Produktname hier</span>&#9;Dokument&#9;&#9;xx.xx.xxxx&#9;<span><img class="_idGenPageitem-10" src="ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt7.png" alt="Icon_bearbeiten.png" /></span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Link CharOverride-8">(= Link zur Suche)</span>&#9;Dokument&#9;&#9;xx.xx.xxxx&#9;<span><img class="_idGenPageitem-10" src="ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt8.png" alt="Icon_bearbeiten.png" /></span></p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Link CharOverride-8">Produktname</span>&#9;Dokument&#9;&#9;xx.xx.xxxx&#9;<span><img class="_idGenPageitem-10" src="ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt9.png" alt="Icon_bearbeiten.png" /></span></p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_dienstleistungen_fmt1.png" alt="Icon_dienstleistungen.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_SOFTWARE_fmt1.png" alt="Icon_SOFTWARE.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_GEBRAUCHSTSOFTWARE_fmt1.png" alt="Icon_GEBRAUCHSTSOFTWARE.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-11" src="ayacandas_210318-web-resources/image/Icon_Ausschreibung_fmt1.png" alt="Icon_Ausschreibung.png" />
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_02-Zentriert">Dokumente</p>
			<p class="Titel_02-Zentriert">Software <br />Forschung &amp; Lehre<br /><br /><br /><br />Hardware</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt7.png" alt="Icon_DOKUMENTE.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_LEHRE%2bFORSCHUNG_fmt1.png" alt="Icon_LEHRE%2bFORSCHUNG.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-12" src="ayacandas_210318-web-resources/image/Icon_Hardware_fmt1.png" alt="Icon_Hardware.png" />
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">&#9;Anbieten&#9;</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Anbieten einer Dienstleistung</p>
			<p class="Titel_01_Links"><span class="CharOverride-11">Nach abgeschlossener Einstellung Ihres Angebotes bleibt <br />dieses für ein Jahr auf der Ayacandas.com zum angegebenen <br />Preis auffindbar.</span></p>
		</div>
		<div class="_idGenPageitem-2">
			<div class="Einfacher-Textrahmen">
				<p class="Titel_04_Links_Abstand ParaOverride-13">Produktitel <span class="dünn">(Was bieten Sie an?)</span></p>
				<p class="kontaktformular ParaOverride-13">|</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Kategorien </p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Informations- und Kommunikationstechnologien </p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">(IT, IKT) für Praxen und Kliniken</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Datenschutzverordnungen</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Preisangabe</p>
				<p class="Kategoriensuche-geteilt ParaOverride-13">EUR Preis von&#9;&#9;&#9;EUR Preis bis</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Beschreibung</p>
				<p class="Kategoriensuche ParaOverride-13">Beschreibung des Produktes</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Dienstleistungs- oder Firmenprofil als PDF-Datei&#9; </p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Spezialisierungen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe der Produktspezialiserungen</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe ihrer Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Bürgen als Referenz</p>
				<p class="Titel_04 ParaOverride-15">Verfügbare Referenzen&#9;Ausgewählte Referenzen</p>
				<p class="FAQ-Text ParaOverride-15">AiDKlinik®</p>
				<p class="FAQ-Text ParaOverride-15">arztkonsultation.de</p>
				<p class="FAQ-Text ParaOverride-15">ClipMed </p>
				<p class="FAQ-Text ParaOverride-15">Cyber-Defense IT-Sicherheit </p>
				<p class="FAQ-Text ParaOverride-15">Healthcare X.0 </p>
				<p class="FAQ-Text ParaOverride-15">iMedOne® Krankenhaus-<br />Informationssystem </p>
				<p class="FAQ-Text ParaOverride-15">Internet Proxy-Server </p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Stichworte </p>
				<p class="Kategoriensuche ParaOverride-13">Max. 7 Tags, durch Komma getrennt</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Produkt hochladen&#9;</p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Gebühr fürs Einstellen dieses Produkts oder Dienstleistung&#9;<span class="CharOverride-16">0,00 EUR</span></p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Einverständnis-Erklärung</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe die anfallenden Gebühren zum Einstellen zur Kenntnis genommen und möchte meinen Eintrag kostenpflichtig veröffentlichen.</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner für das Angebot zur Verfügung.</p>
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt15.png" alt="Icon_HAKEN.png" />
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt16.png" alt="Icon_HAKEN.png" />
			</div>
			<div>
				<p class="Button-Zum-Angebot">Speichern und Veröffentlichen</p>
			</div>
			<div>
				<p class="Button-Zum-Angebot">Für später speichern</p>
			</div>
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">&#9;Anbieten&#9;</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Anbieten eines Dokuments</p>
			<p class="Titel_01_Links"><span class="CharOverride-11">Nach abgeschlossener Einstellung Ihres Angebotes bleibt <br />dieses für ein Jahr auf der Ayacandas.com zum angegebenen <br />Preis auffindbar.</span></p>
		</div>
		<div class="_idGenPageitem-2">
			<div class="Einfacher-Textrahmen">
				<p class="Titel_04_Links_Abstand ParaOverride-13">Produktitel <span class="dünn">(Was bieten Sie an?)</span></p>
				<p class="kontaktformular ParaOverride-13">|</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Kategorien </p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Informations- und Kommunikationstechnologien </p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">(IT, IKT) für Praxen und Kliniken</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Datenschutzverordnungen</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Preisangabe</p>
				<p class="Kategoriensuche-geteilt ParaOverride-13">EUR Preis von&#9;&#9;&#9;EUR Preis bis</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Beschreibung</p>
				<p class="Kategoriensuche ParaOverride-13">Beschreibung des Produktes</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Dienstleistungs- oder Firmenprofil als PDF-Datei&#9; </p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Spezialisierungen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe der Produktspezialiserungen</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe ihrer Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Bürgen als Referenz</p>
				<p class="Titel_04 ParaOverride-15">Verfügbare Referenzen&#9;Ausgewählte Referenzen</p>
				<p class="FAQ-Text ParaOverride-15">AiDKlinik®</p>
				<p class="FAQ-Text ParaOverride-15">arztkonsultation.de</p>
				<p class="FAQ-Text ParaOverride-15">ClipMed </p>
				<p class="FAQ-Text ParaOverride-15">Cyber-Defense IT-Sicherheit </p>
				<p class="FAQ-Text ParaOverride-15">Healthcare X.0 </p>
				<p class="FAQ-Text ParaOverride-15">iMedOne® Krankenhaus-<br />Informationssystem </p>
				<p class="FAQ-Text ParaOverride-15">Internet Proxy-Server </p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Stichworte </p>
				<p class="Kategoriensuche ParaOverride-13">Max. 7 Tags, durch Komma getrennt</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Produkt hochladen&#9;</p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Gebühr fürs Einstellen dieses Produkts oder Dienstleistung&#9;<span class="CharOverride-16">0,00 EUR</span></p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Einverständnis-Erklärung</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe die anfallenden Gebühren zum Einstellen zur Kenntnis genommen und möchte meinen Eintrag kostenpflichtig veröffentlichen.</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner für das Angebot zur Verfügung.</p>
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt17.png" alt="Icon_HAKEN.png" />
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt18.png" alt="Icon_HAKEN.png" />
			</div>
			<div>
				<p class="Button-Zum-Angebot">Speichern und Veröffentlichen</p>
			</div>
			<div>
				<p class="Button-Zum-Angebot">Für später speichern</p>
			</div>
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">&#9;Anbieten&#9;</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Anbieten einer Software</p>
			<p class="Titel_01_Links"><span class="CharOverride-11">Nach abgeschlossener Einstellung Ihres Angebotes bleibt <br />dieses für ein Jahr auf der Ayacandas.com zum angegebenen <br />Preis auffindbar.</span></p>
		</div>
		<div class="_idGenPageitem-2">
			<div class="Einfacher-Textrahmen">
				<p class="Titel_04_Links_Abstand ParaOverride-13">Produktitel <span class="dünn">(Was bieten Sie an?)</span></p>
				<p class="kontaktformular ParaOverride-13">|</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Kategorien </p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Informations- und Kommunikationstechnologien </p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">(IT, IKT) für Praxen und Kliniken</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Datenschutzverordnungen</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Preisangabe</p>
				<p class="Kategoriensuche-geteilt ParaOverride-13">EUR Preis von&#9;&#9;&#9;EUR Preis bis</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Beschreibung</p>
				<p class="Kategoriensuche ParaOverride-13">Beschreibung des Produktes</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Dienstleistungs- oder Firmenprofil als PDF-Datei&#9; </p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Spezialisierungen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe der Produktspezialiserungen</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe ihrer Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Bürgen als Referenz</p>
				<p class="Titel_04 ParaOverride-15">Verfügbare Referenzen&#9;Ausgewählte Referenzen</p>
				<p class="FAQ-Text ParaOverride-15">AiDKlinik®</p>
				<p class="FAQ-Text ParaOverride-15">arztkonsultation.de</p>
				<p class="FAQ-Text ParaOverride-15">ClipMed </p>
				<p class="FAQ-Text ParaOverride-15">Cyber-Defense IT-Sicherheit </p>
				<p class="FAQ-Text ParaOverride-15">Healthcare X.0 </p>
				<p class="FAQ-Text ParaOverride-15">iMedOne® Krankenhaus-<br />Informationssystem </p>
				<p class="FAQ-Text ParaOverride-15">Internet Proxy-Server </p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Stichworte </p>
				<p class="Kategoriensuche ParaOverride-13">Max. 7 Tags, durch Komma getrennt</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Produkt hochladen&#9;</p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Gebühr fürs Einstellen dieses Produkts oder Dienstleistung&#9;<span class="CharOverride-16">0,00 EUR</span></p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Einverständnis-Erklärung</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe die anfallenden Gebühren zum Einstellen zur Kenntnis genommen und möchte meinen Eintrag kostenpflichtig veröffentlichen.</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner für das Angebot zur Verfügung.</p>
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt19.png" alt="Icon_HAKEN.png" />
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt20.png" alt="Icon_HAKEN.png" />
			</div>
			<div>
				<p class="Button-Zum-Angebot">Speichern und Veröffentlichen</p>
			</div>
			<div>
				<p class="Button-Zum-Angebot">Für später speichern</p>
			</div>
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">&#9;Anbieten&#9;</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Anbieten einer Software für <br />Forschung und Lehre</p>
			<p class="Titel_01_Links"><span class="CharOverride-11">Nach abgeschlossener Einstellung Ihres Angebotes bleibt <br />dieses für ein Jahr auf der Ayacandas.com zum angegebenen <br />Preis auffindbar.</span></p>
		</div>
		<div class="_idGenPageitem-2">
			<div class="Einfacher-Textrahmen">
				<p class="Titel_04_Links_Abstand ParaOverride-13">Produktitel <span class="dünn">(Was bieten Sie an?)</span></p>
				<p class="kontaktformular ParaOverride-13">|</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Kategorien </p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Informations- und Kommunikationstechnologien </p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">(IT, IKT) für Praxen und Kliniken</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Datenschutzverordnungen</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Preisangabe</p>
				<p class="Kategoriensuche-geteilt ParaOverride-13">EUR Preis von&#9;&#9;&#9;EUR Preis bis</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Beschreibung</p>
				<p class="Kategoriensuche ParaOverride-13">Beschreibung des Produktes</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Dienstleistungs- oder Firmenprofil als PDF-Datei&#9; </p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Spezialisierungen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe der Produktspezialiserungen</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe ihrer Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Bürgen als Referenz</p>
				<p class="Titel_04 ParaOverride-15">Verfügbare Referenzen&#9;Ausgewählte Referenzen</p>
				<p class="FAQ-Text ParaOverride-15">AiDKlinik®</p>
				<p class="FAQ-Text ParaOverride-15">arztkonsultation.de</p>
				<p class="FAQ-Text ParaOverride-15">ClipMed </p>
				<p class="FAQ-Text ParaOverride-15">Cyber-Defense IT-Sicherheit </p>
				<p class="FAQ-Text ParaOverride-15">Healthcare X.0 </p>
				<p class="FAQ-Text ParaOverride-15">iMedOne® Krankenhaus-<br />Informationssystem </p>
				<p class="FAQ-Text ParaOverride-15">Internet Proxy-Server </p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Stichworte </p>
				<p class="Kategoriensuche ParaOverride-13">Max. 7 Tags, durch Komma getrennt</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Produkt hochladen&#9;</p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Gebühr fürs Einstellen dieses Produkts oder Dienstleistung&#9;<span class="CharOverride-16">0,00 EUR</span></p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Einverständnis-Erklärung</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe die anfallenden Gebühren zum Einstellen zur Kenntnis genommen und möchte meinen Eintrag kostenpflichtig veröffentlichen.</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner für das Angebot zur Verfügung.</p>
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt21.png" alt="Icon_HAKEN.png" />
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt22.png" alt="Icon_HAKEN.png" />
			</div>
			<div>
				<p class="Button-Zum-Angebot">Speichern und Veröffentlichen</p>
			</div>
			<div>
				<p class="Button-Zum-Angebot">Für später speichern</p>
			</div>
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">&#9;Anbieten&#9;</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Anbieten einer Gebrauchtsoftware </p>
			<p class="Titel_01_Links"><span class="CharOverride-11">Nach abgeschlossener Einstellung Ihres Angebotes bleibt <br />dieses für ein Jahr auf der Ayacandas.com zum angegebenen <br />Preis auffindbar.</span></p>
		</div>
		<div class="_idGenPageitem-2">
			<div class="Einfacher-Textrahmen">
				<p class="Titel_04_Links_Abstand ParaOverride-13">Produktitel <span class="dünn">(Was bieten Sie an?)</span></p>
				<p class="kontaktformular ParaOverride-13">|</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Kategorien </p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Informations- und Kommunikationstechnologien </p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">(IT, IKT) für Praxen und Kliniken</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Datenschutzverordnungen</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Preisangabe</p>
				<p class="Kategoriensuche-geteilt ParaOverride-13">EUR Preis von&#9;&#9;&#9;EUR Preis bis</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Beschreibung</p>
				<p class="Kategoriensuche ParaOverride-13">Beschreibung des Produktes</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Dienstleistungs- oder Firmenprofil als PDF-Datei&#9; </p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Spezialisierungen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe der Produktspezialiserungen</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe ihrer Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Bürgen als Referenz</p>
				<p class="Titel_04 ParaOverride-15">Verfügbare Referenzen&#9;Ausgewählte Referenzen</p>
				<p class="FAQ-Text ParaOverride-15">AiDKlinik®</p>
				<p class="FAQ-Text ParaOverride-15">arztkonsultation.de</p>
				<p class="FAQ-Text ParaOverride-15">ClipMed </p>
				<p class="FAQ-Text ParaOverride-15">Cyber-Defense IT-Sicherheit </p>
				<p class="FAQ-Text ParaOverride-15">Healthcare X.0 </p>
				<p class="FAQ-Text ParaOverride-15">iMedOne® Krankenhaus-<br />Informationssystem </p>
				<p class="FAQ-Text ParaOverride-15">Internet Proxy-Server </p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Stichworte </p>
				<p class="Kategoriensuche ParaOverride-13">Max. 7 Tags, durch Komma getrennt</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Produkt hochladen&#9;</p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Gebühr fürs Einstellen dieses Produkts oder Dienstleistung&#9;<span class="CharOverride-16">0,00 EUR</span></p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Einverständnis-Erklärung</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe die anfallenden Gebühren zum Einstellen zur Kenntnis genommen und möchte meinen Eintrag kostenpflichtig veröffentlichen.</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner für das Angebot zur Verfügung.</p>
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt23.png" alt="Icon_HAKEN.png" />
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt24.png" alt="Icon_HAKEN.png" />
			</div>
			<div>
				<p class="Button-Zum-Angebot">Speichern und Veröffentlichen</p>
			</div>
			<div>
				<p class="Button-Zum-Angebot">Für später speichern</p>
			</div>
		</div>
		<div>
			<p class="navi"><span class="CharOverride-14">&#9;Anbieten&#9;</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Anbieten von Hardware und Sonstigem </p>
			<p class="Titel_01_Links"><span class="CharOverride-11">Nach abgeschlossener Einstellung Ihres Angebotes bleibt <br />dieses für ein Jahr auf der Ayacandas.com zum angegebenen <br />Preis auffindbar.</span></p>
		</div>
		<div class="_idGenPageitem-2">
			<div class="Einfacher-Textrahmen">
				<p class="Titel_04_Links_Abstand ParaOverride-13">Produktitel <span class="dünn">(Was bieten Sie an?)</span></p>
				<p class="kontaktformular ParaOverride-13">|</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Kategorien </p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Informations- und Kommunikationstechnologien </p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">(IT, IKT) für Praxen und Kliniken</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-13">Datenschutzverordnungen</p>
				<p class="Kategoriensuche ParaOverride-13">Kategoriensuche</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Preisangabe</p>
				<p class="Kategoriensuche-geteilt ParaOverride-13">EUR Preis von&#9;&#9;&#9;EUR Preis bis</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Beschreibung</p>
				<p class="Kategoriensuche ParaOverride-13">Beschreibung des Produktes</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Dienstleistungs- oder Firmenprofil als PDF-Datei&#9; </p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Spezialisierungen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe der Produktspezialiserungen</p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Angabe ihrer Referenzen</p>
				<p class="Kategoriensuche ParaOverride-13">Bürgen als Referenz</p>
				<p class="Titel_04 ParaOverride-15">Verfügbare Referenzen&#9;Ausgewählte Referenzen</p>
				<p class="FAQ-Text ParaOverride-15">AiDKlinik®</p>
				<p class="FAQ-Text ParaOverride-15">arztkonsultation.de</p>
				<p class="FAQ-Text ParaOverride-15">ClipMed </p>
				<p class="FAQ-Text ParaOverride-15">Cyber-Defense IT-Sicherheit </p>
				<p class="FAQ-Text ParaOverride-15">Healthcare X.0 </p>
				<p class="FAQ-Text ParaOverride-15">iMedOne® Krankenhaus-<br />Informationssystem </p>
				<p class="FAQ-Text ParaOverride-15">Internet Proxy-Server </p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Stichworte </p>
				<p class="Kategoriensuche ParaOverride-13">Max. 7 Tags, durch Komma getrennt</p>
				<p class="Titel_04_Links_Abstand ParaOverride-14">Produkt hochladen&#9;</p>
				<div class="_idGenPageitem-13">
					<p class="Button-Zum-Angebot">Datei hochladen </p>
				</div>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Gebühr fürs Einstellen dieses Produkts oder Dienstleistung&#9;<span class="CharOverride-16">0,00 EUR</span></p>
				<p class="Titel_04_Links_Abstand ParaOverride-13">Einverständnis-Erklärung</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe die anfallenden Gebühren zum Einstellen zur Kenntnis genommen und möchte meinen Eintrag kostenpflichtig veröffentlichen.</p>
				<p class="Text_02_LINKS_EINZUG ParaOverride-16">Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner für das Angebot zur Verfügung.</p>
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt25.png" alt="Icon_HAKEN.png" />
			</div>
			<div class="_idGenPageitem-2">
				<img class="_idGenPageitem-14" src="ayacandas_210318-web-resources/image/Icon_HAKEN_fmt26.png" alt="Icon_HAKEN.png" />
			</div>
			<div>
				<p class="Button-Zum-Angebot">Speichern und Veröffentlichen</p>
			</div>
			<div>
				<p class="Button-Zum-Angebot">Für später speichern</p>
			</div>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Über Ayacandas</p>
			<p class="Text-01--Untertitel-01-">Ayacandas ist ein gut sortierter Online-Marktplatz, auf dem Sie IT-Lösungen für das Gesundheitswesen auf einfachem Weg finden und Ihre eigenen Produkte risikolos anbieten können.</p>
			<p class="Text-01--Untertitel-01-">Viele Krankenhäuser und andere Akteure im Gesundheitswesen entwickeln IT-Lösungen und Formulare in denen viel Zeit, Herzblut, Energie und Geld steckt. Mitarbeitende im Gesundheitssystem suchen oft genau solche Lösungen oder Dokumente. Doch diese sind meist schwer erhältlich.</p>
			<p class="Text-01--Untertitel-01-">Ayacandas bietet einen sicheren Weg IT-Lösungen von ausgezeichneten Kliniken und ausgewählte Produkten von Drittanbietern zu finden und stellt darüber hinaus Foren zum Wissens- und Erfahrungsaustausch zur Verfügung.</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_03_Einzug">Kontakt</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Fett">T</span>   +49 211 54 76 16 0</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Fett">F</span>   +49 211-54 76 16 01</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Fett">M</span>   Kontak@ayacandas.com</p>
		</div>
		<div>
			<p class="Titel_03_Einzug">Kontaktformular</p>
			<p class="kontaktformular">Vorname</p>
			<p class="kontaktformular">Mailadresse</p>
			<p class="kontaktformular">Betreff</p>
			<p class="kontaktformular ParaOverride-17">Nachricht</p>
		</div>
		<div>
			<p class="Titel_03_Einzug">Danksagung</p>
			<p class="Text_02_LINKS_EINZUG">Die Software, die diesem Marktplatz zugrunde liegt, wurde vollständig neu entwickelt von der Firma m-creations, Acker 2, 55116 Mainz, www.m-creations.com unter ihren Geschäftsführern Kambiz Darabi und Frank Pacholak.</p>
			<p class="Text_02_LINKS_EINZUG">Ihnen und dem Team der m-creations möchte ich hier für Ihre ständige tatkräftige Unterstützung explizit danken. Eine technisch komplexe Entwicklung ist nur mit wenigen Firmen möglich, denn diese braucht nicht nur Vertrauen, sondern auch ein gutes gegenseitiges Verständnis Die Software ist</p>
		</div>
		<div>
			<p class="Titel_03_Einzug">Datenschutzverordnung</p>
			<p class="Text_02_LINKS_EINZUG">Die Software, die diesem Marktplatz zugrunde liegt, wurde vollständig neu entwickelt von der Firma m-creations, Acker 2, 55116 Mainz, www.m-creations.com unter ihren Geschäftsführern Kambiz Darabi und Frank Pacholak.</p>
			<p class="Text_02_LINKS_EINZUG">Ihnen und dem Team der m-creations möchte ich hier für Ihre ständige tatkräftige Unterstützung explizit danken. Eine technisch komplexe Entwicklung ist nur mit wenigen Firmen möglic</p>
		</div>
		<div>
			<p class="Titel_03_Einzug">Impressum</p>
			<p class="Text_02_LINKS_EINZUG">Scrollbar??</p>
			<p class="Text_02_LINKS_EINZUG">zugleich Anbieterkennung im Sinne von §§ 5 TMG, 55 RStV</p>
			<p class="Text_02_LINKS_EINZUG">Ayacandas GmbH</p>
			<p class="Text_02_LINKS_EINZUG">In der Aue 9</p>
			<p class="Text_02_LINKS_EINZUG">40591 Düsseldorf</p>
			<p class="Text_02_LINKS_EINZUG">vertreten durch ihren Geschäftsführer:</p>
			<p class="Text_02_LINKS_EINZUG">Dr. Stefan Walther</p>
			<p class="Text_02_LINKS_EINZUG">E-Mail: walther[at]ayacandas.com</p>
			<p class="Text_02_LINKS_EINZUG">Ihnen und dem Team der m-creations möchte ich hier für Ihre ständige tatkräftige Unterstützung explizit danken. Eine technisch komplexe Entwicklung ist nur mit wenigen Firmen möglich, denn diese braucht nicht nur Vertrauen, sondern auch ein gutes gegenseitiges Verständnis Die Software ist eine der wenigen – falls nicht die einzige - Multi-Vendor-Marktplätze, deren Code komplett in europäischer Hand liegt. Ihnen und dem Team der m-creations möchte ich hier für Ihre ständige tatkräftige Unterstützung explizit danken. Eine technisch komplexe Entwicklung ist nur mit tt in europäischer Hand liegt. Ihnen und dem Team der m-creations möchte ich hier für Ihre ständige tatkräftige Unterstützung explizit danken. Eine technisch komplexe Entwicklung ist nur mit </p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_03_Einzug">Geschäftsführung</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">Dr. Stefan Max Walther </p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Fett">T</span>   +49 211 54 76 16 0</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Fett">F</span>   +49 211-54 76 16 01</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"><span class="Fett">M </span>  Walther@ayacandas.com</p>
		</div>
		<div>
			<p class="kontaktformular">Nachname  </p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Hier finden Sie aktuelle Hinweise zu den Produkten, zu Sicherheit und Datenschutz sowie Empfehlungen der Redaktion</p>
		</div>
		<div>
			<p class="Titel_02-Zentriert">Empfehlungen</p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Kurze und Knappe Titel</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">vielleicht sowas wie</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Gesetze und Verordnungen</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Studien</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Formulare</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">weitere Empfehlungen</span></p>
		</div>
		<div class="_idGenPageitem-2">
			<div>
				<p class="navi"><span class="CharOverride-14">&#9;&#9;Aktuelles&#9;</span></p>
			</div>
			<div>
				<p class="navi">It-Sicherheit</p>
			</div>
			<div>
				<p class="navi">Empfehlungen</p>
			</div>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_Empfehlungen_fmt.png" alt="Icon_Empfehlungen.png" />
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_02-Zentriert">IT-Sicherheit</p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Kurze und Knappe Titel</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Organisatorische Unterstützung</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Datenschutz </span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">Abrechnung</span></p>
			<p class="Titel_03_Zentriert"><span class="Link CharOverride-8">weitere Hinweise</span></p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_SICHERHEIT_fmt.png" alt="Icon_SICHERHEIT.png" />
		</div>
		<div class="_idGenPageitem-2">
			<div>
				<p class="navi"><span class="CharOverride-14">&#9;&#9;Aktuelles&#9;</span></p>
			</div>
			<div>
				<p class="navi"><span class="CharOverride-14">It-Sicherheit</span></p>
			</div>
			<div>
				<p class="navi">Empfehlungen</p>
			</div>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Aktuelle gesetzliche Anforderungen </p>
		</div>
		<div>
			<p class="Titel_03_Einzug">2017/2018 - Legislative Anforderungen an die Krankenhaus-IT</p>
		</div>
		<div class="Einfacher-Grafikrahmen">
		</div>
		<div>
			<p class="Titel_03_Einzug">2017/2018 - Legislative Anforderungen an die Krankenhaus-IT</p>
		</div>
		<div>
			<p class="Titel_03_Einzug">2017/2018 - Legislative Anforderungen an die Krankenhaus-IT</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">1. Organisatorische Unterstützung</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">2. Datenschutz &amp; IT-Sicherheit</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">3. Abrechnung</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">1. Organisatorische Unterstützung</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">1.1. Vorbereitung Krankenhaus-Arztnummer (ab 2020)</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">Künftig lebenslange Arztnummer auch für Ärzte im Krankenhaus (KANR)</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">keine Doppelvergabe mit LANR (XOR)</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">1.1.1. RS214-17_Gesetz zur Fortschreibung der Vorschriften für Blut- und Gewebezubereitungen und zur Änderung anderer Vorschriften.pdf</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">1.2. Personaluntergrenzen in der Pflege</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG"> Nachweispflichten für Personal IT-technisch zu unterstützen</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">1.1. Meldung Krankenhausstandorte nach § 2a Abs. 1 KHG i.V.m. § 293 Abs. 6 SGB V (ab Mitte 2018)</p>
		</div>
		<div>
			<p class="Titel_03_Einzug">2017/2018 - Legislative Anforderungen an die Krankenhaus-IT</p>
		</div>
		<div>
			<p class="Titel_03_Einzug">2017/2018 - Legislative Anforderungen an die Krankenhaus-IT</p>
		</div>
		<div>
			<p class="Titel_03_Einzug">2017/2018 - Legislative Anforderungen an die Krankenhaus-IT</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">1. Organisatorische Unterstützung</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">2. Datenschutz &amp; IT-Sicherheit</p>
			<p class="Text_02-LINKS_EINZUG_AUFZ-HLUNG">3. Abrechnung</p>
		</div>
		<div class="_idGenPageitem-2">
			<div>
				<p class="navi"><span class="CharOverride-14">&#9;&#9;Aktuelles&#9;</span></p>
			</div>
			<div>
				<p class="navi">It-Sicherheit</p>
			</div>
			<div>
				<p class="navi"><span class="CharOverride-14">Empfehlungen</span></p>
			</div>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Wir können Ihnen folgende Produkte und Verweise besonders empfehlen</p>
		</div>
		<div class="Wei-eFl-chen">
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04">Integrated Care Manager (ICM) </p>
			<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
				<img class="_idGenPageitem-3" src="ayacandas_210318-web-resources/image/27680.png" alt="27680.png" />
			</div>
			<p class="Text_02_LINKS_EINZUG">Eingeklappte Beschreibung der Suchergebnisse mit maximal <br />zwei Spalten Text, am Ende steht an logischer Stelle ein...</p>
			<p class="Titel_04">Typ<span class="CharOverride-16"> <span><img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt8.png" alt="Icon_DOKUMENTE.png" /></span> </span><span class="Link CharOverride-8">Dokument </span></p>
			<p class="Titel_04">Kategorie <span class="Link CharOverride-8">Europ. DSGVO | Bitte abkürzen</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04">Integrated Care Manager (ICM) </p>
			<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
				<img class="_idGenPageitem-3" src="ayacandas_210318-web-resources/image/27667.png" alt="27667.png" />
			</div>
			<p class="Text_02_LINKS_EINZUG">Ausgeklappte Beschreibung der Suchergebnisse mit maximal <br />sechs Spalten Text der logisch beendet wird. Die genaue <br />Produktbeschreibung gibt es dann auf der jweiligen Produktseite <br />- zu errreichen über den „Zum Angebot“-Button.</p>
			<p class="Titel_04">Typ<span class="CharOverride-16"> <span><img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt9.png" alt="Icon_DOKUMENTE.png" /></span> </span><span class="Link CharOverride-8">Dokument </span></p>
			<p class="Titel_04">Kategorie <span class="Link CharOverride-8">Europ. DSGVO | Bitte abkürzen</span></p>
		</div>
		<div class="Wei-eFl-chen">
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_04">Integrated Care Manager (ICM) </p>
			<div class="Einfacher-Grafikrahmen _idGenPageitem-2">
				<img class="_idGenPageitem-3" src="ayacandas_210318-web-resources/image/27694.png" alt="27694.png" />
			</div>
			<p class="Text_02_LINKS_EINZUG">Eingeklappte Beschreibung der Suchergebnisse mit maximal <br />zwei Spalten Text, am Ende steht an logischer Stelle ein...</p>
			<p class="Titel_04">Typ<span class="CharOverride-16"> <span><img class="_idGenPageitem-4" src="ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt10.png" alt="Icon_DOKUMENTE.png" /></span> </span><span class="Link CharOverride-8">Dokument </span></p>
			<p class="Titel_04">Kategorie <span class="Link CharOverride-8">Europ. DSGVO | Bitte abkürzen</span></p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zum Angebot</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zum Angebot</p>
		</div>
		<div>
			<p class="Button-Zum-Angebot">Zum Angebot</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Text_02_LINKS_EINZUG">Responsive navi geschlossen</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-15" src="ayacandas_210318-web-resources/image/Header_fmt.png" alt="Header.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-16" src="ayacandas_210318-web-resources/image/1358_fmt.png" alt="1358.jpg" />
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Text_02_LINKS_EINZUG">Responsive navi geöffnet</p>
			<p class="Text_02_LINKS_EINZUG">Hintergrund Ayacandas Blau 70 % Transparenz</p>
		</div>
		<div class="Einfacher-Grafikrahmen">
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-15" src="ayacandas_210318-web-resources/image/Header_fmt1.png" alt="Header.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-17" src="ayacandas_210318-web-resources/image/1358_fmt1.png" alt="1358.jpg" />
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="header"><span class="CharOverride-23">AYACANDAS    </span></p>
			<p class="header"><span class="CharOverride-23">DER AUSTAUSCH-MARKTPLATZ FÜR KLINIKEN</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="header"><span class="CharOverride-23">AYACANDAS    </span></p>
			<p class="header"><span class="CharOverride-23">DER AUSTAUSCH-MARKTPLATZ FÜR KLINIKEN</span></p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_01_Links">Ayacandas ist ein Online-Austausch-Marktplatz für IT-Lösungen im Gesundheitswesen.</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_02-Zentriert">Suche</p>
			<p class="Fill-In-Text">      <span class="CharOverride-12"> I  </span>&#9;   </p>
		</div>
		<div>
			<p class="Titel_02-Zentriert">Suchanregungen</p>
		</div>
		<div class="Wei-eFl-chen">
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_02-Zentriert"><br /><br />Aktuelles</p>
		</div>
		<div>
			<p class="navi"><span class="CharOverride-24">Suchen</span></p>
			<p class="navi"><span class="CharOverride-25">Anbieten</span></p>
			<p class="navi"><span class="CharOverride-24">Aktuelles</span></p>
			<p class="navi ParaOverride-18"><span class="CharOverride-24">It-Sicherheit</span></p>
			<p class="navi ParaOverride-18"><span class="CharOverride-24">Empfehlungen</span></p>
			<p class="navi"><span class="CharOverride-24">Meine Daten</span></p>
			<p class="navi"><span class="CharOverride-24">Logout&#9;</span></p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_Aktuelles_fmt1.png" alt="Icon_Aktuelles.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_SUCHANREGUNGEN_fmt1.png" alt="Icon_SUCHANREGUNGEN.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_Suche_fmt1.png" alt="Icon_Suche.png" />
		</div>
		<div>
			<p class="Titel_02-Zentriert">Anbieten</p>
			<p class="Button-Zum-Angebot ParaOverride-5"> Login/Registrierung</p>
		</div>
		<div class="Einfacher-Textrahmen">
			<p class="Titel_02-Zentriert"><br /><br />Informatives</p>
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_Anbieten_fmt1.png" alt="Icon_Anbieten.png" />
		</div>
		<div class="_idGenPageitem-2">
			<img class="_idGenPageitem-1" src="ayacandas_210318-web-resources/image/Icon_Informatives_fmt1.png" alt="Icon_Informatives.png" />
		</div>
	</body>

</div>
		  );
}
}



// WEBPACK FOOTER //
// ./src/ayacandas_210318.js